import React from "react";

const PageNotFound = () => {
  return <div className="flex justify-center m-4 p-4 h-100"><p>404 Page Not Found!</p></div>;
};

export default PageNotFound;
